import { nonNullable } from '@siteless/util';
import avatars from '../config/avatars';
import { AllUserProfilesType } from '../resources/userProfileSchema';

export let getUsersByScoreList = ({
  completedBallots,
  ballotScores,
  allEnums,
  useStrictScore,
  filterToUserIds,
  currentUserId,
}: {
  completedBallots: Record<string, boolean>;
  currentUserId: string;
  filterToUserIds: null | string[];
  useStrictScore: boolean;
  allEnums: AllUserProfilesType;
  ballotScores: Record<string, { score: number; strictScore: number }>;
}) => {
  return Object.entries(ballotScores)
    .filter(
      ([userId]) =>
        completedBallots[userId] &&
        allEnums.users[userId]
    )
    .map(([userId, { score, strictScore }]) => {
      let user = allEnums.users[userId];

      if (!user) return null;
      if (filterToUserIds && !filterToUserIds.includes(userId)) return null;

      return {
        key: userId,
        createdByUserId: userId,
        score: useStrictScore ? strictScore : score,
        ArtworkComponent: avatars[user.avatarId || 'AVATAR_0'].ArtworkComponent,
        handle: user.handle,
        avatarBackgroundHex: user.avatarBackgroundHex || avatars[user.avatarId || 'AVATAR_0'].defaultBackgroundColor,
        letterboxdId: user.letterboxdId,
      };
    })
    .filter(nonNullable)
    .sort((a, b) => {
      if (b.score === a.score) {
        if (a.key === currentUserId) return -1;
        if (b.key === currentUserId) return 1;
        return (a.handle || '').localeCompare(b.handle || '');
      }
      return b.score - a.score;
    });
};
